<script context="module" lang="ts">export { specification } from "./spec";
</script>

<script lang="ts">import { BaseAtom } from "components/cards/atoms";
// MatchHeaderBase props
export let container = undefined;
export let matchStatus = undefined;
export let txtCompetitionName = undefined;
export let txtDateRange = undefined;
export let txtLocationLabel = undefined;
export let txtMatchStateLabel = undefined;
export let txtMatchStateLabelTablet = undefined;
export let txtMatchStateLabelMobile = undefined;
export let imgTeamA = undefined;
export let imgTeamATablet = undefined;
export let imgTeamAMobile = undefined;
export let txtHomeTeamName = undefined;
export let txtHomeTeamNameTablet = undefined;
export let txtHomeTeamNameMobile = undefined;
export let txtHomeTeamScore = undefined;
export let txtHomeTeamScoreTablet = undefined;
export let txtHomeTeamScoreMobile = undefined;
export let txtHomeTeamSubscore = undefined;
export let txtHomeTeamSubscoreTablet = undefined;
export let txtHomeTeamSubscoreMobile = undefined;
export let imgTeamB = undefined;
export let imgTeamBTablet = undefined;
export let imgTeamBMobile = undefined;
export let txtAwayTeamName = undefined;
export let txtAwayTeamNameTablet = undefined;
export let txtAwayTeamNameMobile = undefined;
export let txtAwayTeamScore = undefined;
export let txtAwayTeamScoreTablet = undefined;
export let txtAwayTeamScoreMobile = undefined;
export let txtAwayTeamSubscore = undefined;
export let txtAwayTeamSubscoreTablet = undefined;
export let txtAwayTeamSubscoreMobile = undefined;
export let txtResultLabel = undefined;
export let txtResultLabelTablet = undefined;
export let txtResultLabelMobile = undefined;
export let imgWeatherIcon = undefined;
export let txtTemperatureLabel = undefined;
export let txtWeatherLabel = undefined;
export let btnCTA = undefined;
export let paddingRoot = undefined;
export let paddingRootTablet = undefined;
export let paddingRootCompact = undefined;
export let gapRoot = undefined;
export let gapRootCompact = undefined;
export let gapScorecard = undefined;
export let paddingScorecardTopCompact = undefined;
export let gapScorecardCompact = undefined;
export let gapInfoBar = undefined;
export let gapWeatherDisplay = undefined;
// Cricket-only fields
export let oversJson = undefined;
export let ballBoxContainer = undefined;
export let ballBoxScoringContainer = undefined;
export let dividerColor = undefined;
export let dividerThickness = undefined;
export let dividerMargin = undefined;
export let gapOversWrap = undefined;
export let paddingOversWrapCompact = undefined;
export let gapOversScroll = undefined;
export let gapOversScrollCompact = undefined;
export let paddingOversScroll = undefined;
export let paddingOversScrollCompact = undefined;
export let gapOverBallsRow = undefined;
export let gapOverBalls = undefined;
export let widthOverCard = undefined;
export let colorBallBox = undefined;
export let colorBallBoxScoring = undefined;
export let colorOverLabel = undefined;
</script>

<BaseAtom
  _isotope="CricketMatchHeaderAtom"
  {...container}
  _cssVariablePrefix="cricket-match-header"
>
  cricket match header
</BaseAtom>

<style>
  .cricket-match-header {
    width: 100%;
  }</style>
